"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnonymousStudentServiceReady = void 0;
const enumerations_1 = require("../enumerations");
class AnonymousStudentServiceReady {
    constructor(anonymousStudentService) {
        this.eventType = AnonymousStudentServiceReady.EventType;
        this.timestamp = new Date();
        this.anonymousStudentService = anonymousStudentService;
    }
}
exports.AnonymousStudentServiceReady = AnonymousStudentServiceReady;
AnonymousStudentServiceReady.EventType = enumerations_1.EventType.AnonymousStudentServiceReady;
